import React from 'react';
import { LOGO_IMG } from '../mock';

// Bluu Sky official logo (uses attached asset)
const Logo = ({ compact = false, dark = false }) => {
  const height = compact ? 56 : 72;
  return (
    <div className="flex items-center gap-2.5 select-none">
      <img
        src={LOGO_IMG}
        alt="Bluu Sky Private Limited"
        style={{ height, width: 'auto' }}
        className={`${dark ? '' : ''} object-contain drop-shadow-[0_4px_10px_rgba(245,144,31,0.15)]`}
      />
    </div>
  );
};

export default Logo;
